import { render, staticRenderFns } from "./SuccessionFiles.vue?vue&type=template&id=8efb9462&scoped=true&"
import script from "./SuccessionFiles.vue?vue&type=script&lang=js&"
export * from "./SuccessionFiles.vue?vue&type=script&lang=js&"
import style0 from "./SuccessionFiles.vue?vue&type=style&index=0&id=8efb9462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efb9462",
  null
  
)

export default component.exports